import { EventChannel, multicastChannel, MulticastChannel } from 'redux-saga';
import { all, call, delay, fork, put, take } from 'typed-redux-saga';

import { setDebugMenuStatsReport } from '../../../../../shared/features/room-agent/dtmf/debug-menu/actions';
import { ChannelHolder } from '../../../../../shared/helpers/channelHolder';
import {
    DrawingPerformanceStats,
    DrawingPerformanceStatsReport,
} from '../../../../../shared/helpers/drawing-performance-stats';
import { SignalingAPI } from '../api/SignalingAPI';
import { collectOutboundVideoSample } from '../transcoder-observability/helpers/collect-outbound-stats';

function* debugMenuStatsSaga(drawingPerformanceStatsChannel: MulticastChannel<DrawingPerformanceStatsReport>) {
    while (true) {
        const { drawingPerformanceStats } = yield* all({
            drawingPerformanceStats: take(drawingPerformanceStatsChannel, '*'),
            throttle: delay(5000),
        });

        yield* put(setDebugMenuStatsReport({ drawingPerformance: drawingPerformanceStats }));
    }
}

function* signalingStatsSaga(
    drawingPerformanceStatsChannel: MulticastChannel<DrawingPerformanceStatsReport>,
    signaling: SignalingAPI
) {
    while (true) {
        const { drawingPerformanceStats } = yield* all({
            drawingPerformanceStats: take(drawingPerformanceStatsChannel, '*'),
            throttle: delay(10000),
        });

        yield* call([signaling, signaling.onStats], drawingPerformanceStats);
    }
}

function* outboundStatsSaga(
    performanceStatsChannel: EventChannel<[DrawingPerformanceStatsReport]>,
    drawingPerformanceStatsChannel: MulticastChannel<DrawingPerformanceStatsReport>
) {
    while (true) {
        const [report] = yield* take(performanceStatsChannel);
        const outbound = yield* call(collectOutboundVideoSample);
        yield* put(drawingPerformanceStatsChannel, { ...report, ...outbound });
    }
}

export function* statsSaga({ signaling, channelHolder }: { signaling: SignalingAPI; channelHolder: ChannelHolder }) {
    const drawingPerformanceStatsCollector = new DrawingPerformanceStats({ interval: 5000 });
    const drawingPerformanceStatsChannel = multicastChannel<DrawingPerformanceStatsReport>();
    const performanceStatsChannel = channelHolder.getChannelForEmmiter<DrawingPerformanceStatsReport>(
        drawingPerformanceStatsCollector,
        'performance-stats'
    );

    yield* fork(debugMenuStatsSaga, drawingPerformanceStatsChannel);
    yield* fork(signalingStatsSaga, drawingPerformanceStatsChannel, signaling);
    yield* fork(outboundStatsSaga, performanceStatsChannel, drawingPerformanceStatsChannel);
}
